import { Flex } from "@mantine/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { InvoicesTable } from "../../../components/Invoice/InvoicesTable/InvoicesTable.tsx";
import { InvoiceFilter, RolePermission } from "../../../graphql/generated";
import { useCurrentUserContext } from "../../../providers/CurrentUserProvider.tsx";
import { hasPermission } from "../../../utils/user.ts";
import InvoiceDetailTab from "../InvoiceDetailTab/InvoiceDetailTab.tsx";
import InvoicesFilterToolbar from "../InvoicesFilterToolbar/InvoicesFilterToolbar.tsx";
import { FiltersValue } from "../InvoicesFilterToolbar/types.ts";
import { useStyles } from "./InvoicesTab.styles.ts";
import { getInvoiceApiFilter } from "./utils.ts";

const InvoicesTab = () => {
  const { classes } = useStyles();
  const { customerId } = useParams() as { customerId: string };

  const { user } = useCurrentUserContext();
  const canEditCollectorAssigned = hasPermission(
    user,
    RolePermission.CanAssignInvoiceCollector
  );

  const [searchParams] = useSearchParams();
  const invoiceIdParam = searchParams.get("invoiceId");
  const invoiceId = invoiceIdParam ? Number(invoiceIdParam) : null;

  const [selectedInvoiceId, setSelectedInvoiceId] = useState<number | null>();

  const customerFilter = useMemo((): InvoiceFilter => {
    return { customerId: { equals: Number(customerId) } };
  }, [customerId]);
  const [filter, setFilter] = useState<InvoiceFilter>(customerFilter);

  const handleFilterChange = useCallback(
    (value: FiltersValue) => {
      setFilter({
        ...getInvoiceApiFilter(value),
        ...customerFilter,
      });
    },
    [customerFilter]
  );

  useEffect(() => {
    if (invoiceId) {
      setSelectedInvoiceId(invoiceId);
    }
  }, [invoiceId]);

  return (
    <>
      {selectedInvoiceId ? (
        <InvoiceDetailTab
          invoiceId={selectedInvoiceId}
          onBreadcrumbsClick={() => {
            setSelectedInvoiceId(null);
          }}
        />
      ) : (
        <Flex
          direction="column"
          align="flex-start"
          gap={{ base: 14, sm: 20 }}
          className={classes.wrapper}
        >
          <InvoicesFilterToolbar onValueChange={handleFilterChange} />
          <InvoicesTable
            filter={filter}
            canEditCollectorAssigned={canEditCollectorAssigned}
            onClickRow={(invoice) => setSelectedInvoiceId(invoice.id)}
          />
        </Flex>
      )}
    </>
  );
};

export default InvoicesTab;
